import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.canChangePassword}}
  <div class="control-group pref-password" data-setting-name="user-password">
    <label class="control-label">{{i18n "user.password.title"}}</label>
    <div class="controls">
      <a href {{on "click" this.changePassword}} class="btn btn-default">
        {{d-icon "envelope"}}
        {{#if this.model.no_password}}
          {{i18n "user.change_password.set_password"}}
        {{else}}
          {{i18n "user.change_password.action"}}
        {{/if}}
      </a>

      {{this.passwordProgress}}
    </div>
  </div>

  {{#if this.canUsePasskeys}}
    <UserPreferences::UserPasskeys @model={{@model}} />
  {{/if}}

  {{#if this.isCurrentUser}}
    <div
      class="control-group pref-second-factor"
      data-setting-name="user-second-factor"
    >
      <label class="control-label">{{i18n "user.second_factor.title"}}</label>
      <div class="instructions">
        {{i18n "user.second_factor.short_description"}}
      </div>

      <div class="controls pref-second-factor">
        <DButton
          @action={{this.manage2FA}}
          @icon="lock"
          @label="user.second_factor.enable"
          class="btn-second-factor"
        />
      </div>
    </div>
  {{/if}}
{{/if}}

{{#if this.canCheckEmails}}
  <div
    class="control-group pref-auth-tokens"
    data-setting-name="user-auth-tokens"
  >
    <label class="control-label">{{i18n "user.auth_tokens.title"}}</label>
    <div class="instructions">
      {{i18n "user.auth_tokens.short_description"}}
    </div>
    <div class="auth-tokens">
      {{#each this.authTokens as |token|}}
        <div class="row auth-token">
          <div class="auth-token-icon">{{d-icon token.icon}}</div>
          {{#unless token.is_active}}
            <AuthTokenDropdown
              @token={{token}}
              @revokeAuthToken={{action "revokeAuthToken"}}
              @showToken={{action "showToken"}}
            />
          {{/unless}}
          <div class="auth-token-first">
            {{html-safe
              (i18n
                "user.auth_tokens.device_location"
                device=token.device
                ip=token.client_ip
                location=token.location
              )
            }}
          </div>
          <div class="auth-token-second">
            {{#if token.is_active}}
              {{html-safe
                (i18n "user.auth_tokens.browser_active" browser=token.browser)
              }}
            {{else}}
              {{html-safe
                (i18n
                  "user.auth_tokens.browser_last_seen"
                  browser=token.browser
                  date=(format-date token.seen_at)
                )
              }}
            {{/if}}
          </div>
        </div>
      {{/each}}
    </div>

    {{#if this.canShowAllAuthTokens}}
      <a href {{on "click" this.toggleShowAllAuthTokens}}>
        {{#if this.showAllAuthTokens}}
          {{d-icon "caret-up"}}
          {{i18n "user.auth_tokens.show_few"}}
        {{else}}
          {{d-icon "caret-down"}}
          {{i18n
            "user.auth_tokens.show_all"
            count=this.model.user_auth_tokens.length
          }}
        {{/if}}
      </a>
    {{/if}}

    <a
      href
      {{on "click" (fn this.revokeAuthToken null)}}
      class="pull-right text-danger"
    >{{d-icon "sign-out-alt"}} {{i18n "user.auth_tokens.log_out_all"}}</a>
  </div>
{{/if}}

<UserPreferences::UserApiKeys @model={{@model}} />

<span>
  <PluginOutlet
    @name="user-preferences-security"
    @connectorTagName="div"
    @outletArgs={{hash model=this.model save=(action "save")}}
  />
</span>

<br />

<span>
  <PluginOutlet
    @name="user-custom-controls"
    @connectorTagName="div"
    @outletArgs={{hash model=this.model}}
  />
</span>
*/
{
  "id": "u0fbDNjA",
  "block": "[[[41,[30,0,[\"canChangePassword\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group pref-password\"],[14,\"data-setting-name\",\"user-password\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,1],[\"user.password.title\"],null]],[13],[1,\"\\n    \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n      \"],[11,3],[24,6,\"\"],[24,0,\"btn btn-default\"],[4,[38,2],[\"click\",[30,0,[\"changePassword\"]]],null],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"envelope\"],null]],[1,\"\\n\"],[41,[30,0,[\"model\",\"no_password\"]],[[[1,\"          \"],[1,[28,[35,1],[\"user.change_password.set_password\"],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,1],[\"user.change_password.action\"],null]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\\n      \"],[1,[30,0,[\"passwordProgress\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canUsePasskeys\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@model\"],[[30,1]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isCurrentUser\"]],[[[1,\"    \"],[10,0],[14,0,\"control-group pref-second-factor\"],[14,\"data-setting-name\",\"user-second-factor\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,1],[\"user.second_factor.title\"],null]],[13],[1,\"\\n      \"],[10,0],[14,0,\"instructions\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"user.second_factor.short_description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,0],[14,0,\"controls pref-second-factor\"],[12],[1,\"\\n        \"],[8,[39,5],[[24,0,\"btn-second-factor\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"manage2FA\"]],\"lock\",\"user.second_factor.enable\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"\\n\"],[41,[30,0,[\"canCheckEmails\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group pref-auth-tokens\"],[14,\"data-setting-name\",\"user-auth-tokens\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,[28,[35,1],[\"user.auth_tokens.title\"],null]],[13],[1,\"\\n    \"],[10,0],[14,0,\"instructions\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"user.auth_tokens.short_description\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"auth-tokens\"],[12],[1,\"\\n\"],[42,[28,[37,7],[[28,[37,7],[[30,0,[\"authTokens\"]]],null]],null],null,[[[1,\"        \"],[10,0],[14,0,\"row auth-token\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"auth-token-icon\"],[12],[1,[28,[35,3],[[30,2,[\"icon\"]]],null]],[13],[1,\"\\n\"],[41,[51,[30,2,[\"is_active\"]]],[[[1,\"            \"],[8,[39,9],null,[[\"@token\",\"@revokeAuthToken\",\"@showToken\"],[[30,2],[28,[37,10],[[30,0],\"revokeAuthToken\"],null],[28,[37,10],[[30,0],\"showToken\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"          \"],[10,0],[14,0,\"auth-token-first\"],[12],[1,\"\\n            \"],[1,[28,[35,11],[[28,[37,1],[\"user.auth_tokens.device_location\"],[[\"device\",\"ip\",\"location\"],[[30,2,[\"device\"]],[30,2,[\"client_ip\"]],[30,2,[\"location\"]]]]]],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"auth-token-second\"],[12],[1,\"\\n\"],[41,[30,2,[\"is_active\"]],[[[1,\"              \"],[1,[28,[35,11],[[28,[37,1],[\"user.auth_tokens.browser_active\"],[[\"browser\"],[[30,2,[\"browser\"]]]]]],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,11],[[28,[37,1],[\"user.auth_tokens.browser_last_seen\"],[[\"browser\",\"date\"],[[30,2,[\"browser\"]],[28,[37,12],[[30,2,[\"seen_at\"]]],null]]]]],null]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[2]],null],[1,\"    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canShowAllAuthTokens\"]],[[[1,\"      \"],[11,3],[24,6,\"\"],[4,[38,2],[\"click\",[30,0,[\"toggleShowAllAuthTokens\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showAllAuthTokens\"]],[[[1,\"          \"],[1,[28,[35,3],[\"caret-up\"],null]],[1,\"\\n          \"],[1,[28,[35,1],[\"user.auth_tokens.show_few\"],null]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,3],[\"caret-down\"],null]],[1,\"\\n          \"],[1,[28,[35,1],[\"user.auth_tokens.show_all\"],[[\"count\"],[[30,0,[\"model\",\"user_auth_tokens\",\"length\"]]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[11,3],[24,6,\"\"],[24,0,\"pull-right text-danger\"],[4,[38,2],[\"click\",[28,[37,13],[[30,0,[\"revokeAuthToken\"]],null],null]],null],[12],[1,[28,[35,3],[\"sign-out-alt\"],null]],[1,\" \"],[1,[28,[35,1],[\"user.auth_tokens.log_out_all\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[8,[39,14],null,[[\"@model\"],[[30,1]]],null],[1,\"\\n\\n\"],[10,1],[12],[1,\"\\n  \"],[8,[39,15],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-preferences-security\",\"div\",[28,[37,16],null,[[\"model\",\"save\"],[[30,0,[\"model\"]],[28,[37,10],[[30,0],\"save\"],null]]]]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,\"br\"],[12],[13],[1,\"\\n\\n\"],[10,1],[12],[1,\"\\n  \"],[8,[39,15],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"user-custom-controls\",\"div\",[28,[37,16],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n\"],[13]],[\"@model\",\"token\"],false,[\"if\",\"i18n\",\"on\",\"d-icon\",\"user-preferences/user-passkeys\",\"d-button\",\"each\",\"-track-array\",\"unless\",\"auth-token-dropdown\",\"action\",\"html-safe\",\"format-date\",\"fn\",\"user-preferences/user-api-keys\",\"plugin-outlet\",\"hash\"]]",
  "moduleName": "discourse/templates/preferences/security.hbs",
  "isStrictMode": false
});